module.exports = __webpack_public_path__ + "static/media/upload_product_icon.5c7d1849.svg";